import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { ExternalLink } from "lucide-react";
import type { Block } from "@/types/proposals";

interface ButtonBlockProps {
  block: Block;
  onUpdate: (updates: Partial<Block>) => void;
  isTemplate?: boolean;
}

export function ButtonBlock({ block, onUpdate, isTemplate }: ButtonBlockProps) {
  const buttonText = block.settings?.buttonText || 'Click Here';
  const buttonUrl = block.settings?.buttonUrl || '#';
  const buttonColor = block.settings?.buttonColor || 'primary';
  const blockSize = block.settings?.blockSize || 'medium';
  const textAlign = block.style?.textAlign || 'center';

  const buttonSize = {
    small: 'sm',
    medium: 'default',
    large: 'lg',
  }[blockSize] as 'sm' | 'default' | 'lg';

  const alignClass = {
    left: 'justify-start',
    center: 'justify-center',
    right: 'justify-end'
  }[textAlign];

  const handleClick = () => {
    if (!isTemplate && buttonUrl && buttonUrl !== '#') {
      window.open(buttonUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <Card 
      className={`p-6 flex ${alignClass}`}
    >
      <Button
        size={buttonSize as any}
        variant={buttonColor === 'primary' ? 'default' : 'outline'}
        onClick={handleClick}
        className={isTemplate ? 'cursor-default' : ''}
      >
        {buttonText}
        <ExternalLink className="w-4 h-4 ml-2" />
      </Button>
    </Card>
  );
}
